(() => {
  const HEADER_SELECTOR = '.shopify-section--header-renewal';
  const MOBILE_MENU_BTN_SELECTOR = '.header-mobile-menu-btn > a';
  const MOBILE_MENU_CLOSE_SELECTOR = '.menu01 > .menu01-close > a';
  const MOBILE_MENU_ATTR = 'data-mobile-menu';
  const MOBILE_MENU_OPEN = 'open';
  const MOBILE_MENU_CLOSED = 'closed';
  const SUBMENU_TRIGGER_SELECTOR = '.menu01 li[data-submenu] > a';
  const SUBMENU_ATTR = 'data-submenu';
  const SUBMENU_OPEN = 'open';
  const SUBMENU_CLOSED = 'closed';
  const FEATURE_HASH_LINK_SELECTOR = '.menu01 a[href*="#feature"]';

  const setHeaderHeight = (header) => {
    if (!header) return;
    document.documentElement.style.setProperty(
      '--header-height',
      `${header.clientHeight.toFixed(2)}px`
    );
  };

  const initHeaderHeight = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    document.documentElement.style.setProperty('--header-is-sticky', '1');
    setHeaderHeight(header);

    const resizeObserver = new ResizeObserver(() => {
      setHeaderHeight(header);
    });
    resizeObserver.observe(header);
  };

  const setMobileMenuState = (state) => {
    document.body.setAttribute(MOBILE_MENU_ATTR, state);
  };

  const toggleMobileMenuState = () => {
    const current = document.body.getAttribute(MOBILE_MENU_ATTR);
    setMobileMenuState(
      current === MOBILE_MENU_OPEN ? MOBILE_MENU_CLOSED : MOBILE_MENU_OPEN
    );
  };

  const initMobileMenuToggle = () => {
    setMobileMenuState(MOBILE_MENU_CLOSED);

    document.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest(MOBILE_MENU_CLOSE_SELECTOR);
      if (closeTrigger) {
        event.preventDefault();
        setMobileMenuState(MOBILE_MENU_CLOSED);
        return;
      }

      const featureHashLink = event.target.closest(FEATURE_HASH_LINK_SELECTOR);
      if (featureHashLink) {
        setMobileMenuState(MOBILE_MENU_CLOSED);
        return;
      }

      const submenuTrigger = event.target.closest(SUBMENU_TRIGGER_SELECTOR);
      if (submenuTrigger) {
        event.preventDefault();
        const item = submenuTrigger.parentElement;
        if (!item) return;

        const willOpen = item.getAttribute(SUBMENU_ATTR) !== SUBMENU_OPEN;
        const parentList = item.parentElement;

        if (parentList) {
          [...parentList.children].forEach((sibling) => {
            if (
              sibling !== item &&
              sibling.nodeType === 1 &&
              sibling.hasAttribute(SUBMENU_ATTR)
            ) {
              sibling.setAttribute(SUBMENU_ATTR, SUBMENU_CLOSED);
            }
          });
        }

        item.setAttribute(SUBMENU_ATTR, willOpen ? SUBMENU_OPEN : SUBMENU_CLOSED);
        return;
      }

      const openTrigger = event.target.closest(MOBILE_MENU_BTN_SELECTOR);
      if (!openTrigger) return;

      event.preventDefault();
      toggleMobileMenuState();
    });
  };

  const initToTopButton = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.totop-btn > a');
      if (!trigger) return;

      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  };

  const init = () => {
    initHeaderHeight();
    initMobileMenuToggle();
    initToTopButton();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
